import api from './api';

const scadenzarioApi = {
  getMeta: () => api.get('/scadenzario/meta'),
  searchClienti: (search) =>
    api.get('/scadenzario/clienti/search', { params: { search } }),
  listEmailAccounts: () => api.get('/scadenzario/email-accounts'),

  getPiani: (params) => api.get('/scadenzario/piani', { params }),
  getPianoById: (id) => api.get(`/scadenzario/piani/${id}`),
  createPiano: (payload) => api.post('/scadenzario/piani', payload),
  updatePiano: (id, payload) => api.put(`/scadenzario/piani/${id}`, payload),
  generaRate: (id) => api.post(`/scadenzario/piani/${id}/genera-rate`),
  rinegoziaPiano: (id, payload) =>
    api.post(`/scadenzario/piani/${id}/rinegozia`, payload),
  importaPianiCsv: (file, referenteUserId, options = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('referente_user_id', String(referenteUserId));
    if (options.forcedDerivanteDa) {
      formData.append('forced_derivante_da', String(options.forcedDerivanteDa));
    }
    if (options.clearScope) {
      formData.append('clear_scope', String(options.clearScope));
    }
    return api.post('/scadenzario/piani/importa', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  getRate: (params) => api.get('/scadenzario/rate', { params }),
  getKpiProiezionePiani: (params) =>
    api.get('/scadenzario/kpi/proiezione-piani', { params }),
  getKpiReferentiPiani: (params) =>
    api.get('/scadenzario/kpi/referenti-piani', { params }),
  getKpiPerformanceReferenti: (params) =>
    api.get('/scadenzario/kpi/performance-referenti', { params }),
  downloadKpiPerformanceReferentiReport: (payload) =>
    api.post('/scadenzario/kpi/performance-referenti/report', payload, {
      responseType: 'blob',
    }),
  startKpiPerformanceReferentiReportJob: (payload) =>
    api.post('/scadenzario/kpi/performance-referenti/report-job', payload),
  updatePagamentoRata: (id, payload) =>
    api.patch(`/scadenzario/rate/${id}/pagamento`, payload),
  deleteRata: (id) => api.delete(`/scadenzario/rate/${id}`),
  listPagamentiRata: (id) => api.get(`/scadenzario/rate/${id}/pagamenti`),
  createPagamentoRata: (id, payload) =>
    api.post(`/scadenzario/rate/${id}/pagamenti`, payload),
  annullaPagamentoRata: (pagamentoId, payload = {}) =>
    api.post(`/scadenzario/pagamenti/${pagamentoId}/annulla`, payload),
  listSollecitiRata: (id) => api.get(`/scadenzario/rate/${id}/solleciti`),
  createSollecitoRata: (id, payload) =>
    api.post(`/scadenzario/rate/${id}/solleciti`, payload),
  listPromesseRata: (id) => api.get(`/scadenzario/rate/${id}/promesse`),
  createPromessaRata: (id, payload) =>
    api.post(`/scadenzario/rate/${id}/promesse`, payload),
  updatePromessaRata: (promessaId, payload) =>
    api.patch(`/scadenzario/promesse/${promessaId}`, payload),
  listTemplateSolleciti: (params) =>
    api.get('/scadenzario/template-solleciti', { params }),
  createTemplateSolleciti: (payload) =>
    api.post('/scadenzario/template-solleciti', payload),
  updateTemplateSolleciti: (templateId, payload) =>
    api.patch(`/scadenzario/template-solleciti/${templateId}`, payload),
  seedTemplateSolleciti: () => api.post('/scadenzario/template-solleciti/seed'),
  listStoricoRata: (id) => api.get(`/scadenzario/rate/${id}/storico`),
  inviaPromemoria: (payload) => api.post('/scadenzario/rate/promemoria', payload),
};

export default scadenzarioApi;
